import React from 'react';
import moment from 'moment';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { EMPTY_GRID_DEFAULT_MESSAGE, } from '../../../modules/Constants';
import SearchBar from '../../searchbar/SearchBar';
import FieldSet from '../../fieldset/FieldSet';
import Grid from '../../grid/Grid';
import CitationsService from '../../../service/CitationsService';
import CitationModal from './CitationModal';

class CitationView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      citations: [],
      rows: [],
      headers: [],
    };
    this.comboFields = [
      {
        value: 'customerId',
        display: 'Customer ID',
      },
      {
        value: 'transactionId',
        display: 'Transaction ID',
      },
      {
        value: 'citationId',
        display: 'Citation ID',
      },
    ];
  }

  state = undefined;

  onRowSelect(row) {
    this.setState({
      selectedCase: row,
    });
  }

  getCitationActivity(event) {
    const { search, combo, } = event;
    const { serviceOfferingId, } = this.props;
    this.reset();
    const vm = this;
    const rows = [];
    let headers = [];

    const criteria = {};
    criteria[combo.value] = search.value;
    criteria.serviceOfferingId = serviceOfferingId;

    const allowedKeys = [
      'id',
      'caseNumber',
      'description',
      'status',
      'updatedAt',
      'customerIds',
    ];

    CitationsService.getCitationsBySearchCriteria(criteria)
      .then((response) => {
        const { citations, } = response.data;
        this.setState({ citations, });
        if (citations.length > 0) {
          headers = allowedKeys.map(header => ({
            value: header,
            display: _.startCase(header),
          }));

          citations.forEach((citation) => {
            const filtered = {};
            filtered.id = citation.citationLookup.citationId;
            filtered.caseNumber = citation.citationLookup.longCaseNumber
              || citation.citationLookup.shortCaseNumber || citation.citationLookup.citationNumber;
            filtered.description = citation.citationLookup.violationDescription;
            filtered.status = citation.citationLookup.status;
            filtered.updatedAt = moment(citation.citationLookup.updatedAt).utc().format();
            filtered.customerIds = citation.links.reduce((accumulator, current) => accumulator + (accumulator ? '\n' : '') + current.customerId, '');

            const row = Object.values(filtered);

            rows.push({ value: row, });
          });
          vm.setState({
            headers,
            rows,
          });
        }
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        event.kill();
      });
  }

  formatSelectedRowDisplay(citation) {
    if (!citation) {
      return null;
    }
    return (
      <div>
        <p>{`Selected ID: ${citation.citationLookup.citationId}`}</p>
        <hr />
        <CitationModal citation={citation} />
      </div>
    );
  }

  reset() {
    this.setState({
      citations: [],
      selectedCase: null,
      headers: [],
      rows: [],
    });
  }

  render() {
    const {
      citations,
      headers,
      rows,
      selectedCase,
    } = this.state;
    const style = {
      maxHeight: '400px',
      overflowY: 'auto',
    };
    return (
      <div className="container">
        <SearchBar comboFields={this.comboFields} onClick={data => this.getCitationActivity(data)} />
        <div style={{ marginTop: '50px', }}>
          <FieldSet title="Citations" style={style}>
            <Grid
              headers={headers}
              rows={rows}
              onRowSelect={row => this.onRowSelect(citations.find(x => x.citationLookup.citationId === row.id))}
              onEmptyGridMessage={EMPTY_GRID_DEFAULT_MESSAGE}
            />
          </FieldSet>
          {this.formatSelectedRowDisplay(selectedCase)}
        </div>
      </div>
    );
  }
}

CitationView.propTypes = {
  serviceOfferingId: PropTypes.string.isRequired,
};

export default CitationView;
